import { select } from "@redux-saga/core/effects";
import { takeEvery, call, put } from "redux-saga/effects";
import { SubmissionError } from "redux-form";
import { waitForFcmToken } from "../../store/sagas/firebase";
import { atLeast, validateValues } from "../../utils/validation";
import { submitFormRoutine } from "./actions";
import AuthService from "../../services/auth";

function* validate({ payload: { values } }) {
  const errors = validateValues(values, {
    verificationCode: [ atLeast(4) ],
  });

  if (errors) {
    yield put(submitFormRoutine.failure(new SubmissionError(errors)));
  } else {
    yield call(sendFormDataToServer, values);
  }

  yield put(submitFormRoutine.fulfill());
}

function* sendFormDataToServer(values) {
  try {
    yield put(submitFormRoutine.request());
    yield waitForFcmToken();
    const { firebase } = yield select();
    const data = yield call(AuthService.authVerify, {
      ...values,
      fcmToken: firebase.fcmToken,
    });
    // const data = {"token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJQaG9uZSI6Ijk4MDMwOTg4OSIsIlBob25lLkNvdW50cnlDb2RlLklkIjoiMjI0IiwibmJmIjoxNTk1MDgzNzAyLCJleHAiOjE1OTc2NzU3MDIsImlhdCI6MTU5NTA4MzcwMiwiaXNzIjoiQ1RHIn0.WPaI5zYMPomdW9ZjP0Q0-Ywn0YDylB82vZvg4VW-JNU","client":{"registration":{"termAndPolicyAgreed":true,"fullName":false},"firstName":"Andrey","lastName":"Bekh","phone":{"phone":"980309889","countryCode":{"id":224,"name":"Ukraine","dialCode":"+380","isoCode":"ua","digits":[9]}},"email":"andrey@tecorien.com","account":{"id":"71170","name":"CTG Consumer Mobile APP"}}};
    if (!!data) {
      yield put(submitFormRoutine.success(data));
    }

  } catch (error) {
    let err = {};
    if (error.errorCode === 1004) {
      err = {
        type: "requestLimitReached",
        message: "Request limit reached",
      };
    } else if (error.errorCode === 1008) {
      err = {
        type: "invalidCode",
        message: "Code is incorrect",
      };
    } else if (error.errorCode === 1006) {
      err = {
        type: "invalidCode",
        message: "Code is incorrect",
      };
    } else {
      err = {
        type: "requestError",
        message: "Request error",
      };
    }
    yield put(submitFormRoutine.failure(new SubmissionError({ _error: err })));

  }
}

export default [
  takeEvery(submitFormRoutine.TRIGGER, validate),
];
